// File: src/blueprint/state/selectors.js

export function selectBlueprint(state) {
  return state?.blueprint ?? null;
}

export function selectModules(state) {
  const modules = state?.blueprint?.modules;
  return Array.isArray(modules) ? modules : [];
}

export function selectActiveModuleId(state) {
  return state?.activeModuleId ?? null;
}

export function selectActiveTrackId(state) {
  return state?.activeTrackId ?? null;
}

export function selectActiveModule(state) {
  const id = selectActiveModuleId(state);
  if (!id) return null;

  const modules = selectModules(state);
  return modules.find((m) => m?.id === id) ?? null;
}

export function selectActiveModuleDoc(state) {
  return state?.activeModuleDoc ?? null;
}

export function selectActiveSteps(state) {
  const doc = selectActiveModuleDoc(state);
  const steps = doc?.steps;
  return Array.isArray(steps) ? steps : [];
}

export function selectOverallProgressPercent(state) {
  const modules = selectModules(state);

  let answered = 0;
  let total = 0;

  for (const module of modules) {
    const moduleAnswered = Number(module?.answered_count ?? module?.completedSteps ?? 0) || 0;
    const moduleTotal =
      Number(module?.total_count ?? module?.totalSteps ?? module?.stepsCount ?? 0) || 0;

    answered += Math.min(moduleAnswered, moduleTotal);
    total += moduleTotal;
  }

  if (total <= 0) {
    return 0;
  }

  const pct = Math.round((answered / total) * 100);
  return Math.max(0, Math.min(100, pct));
}

export function selectModulePercent(module) {
  const ratio = Number(module?.progress_ratio ?? 0) || 0;
  const pct = Math.round(ratio * 100);

  return Math.max(0, Math.min(100, pct));
}

export function selectModuleStepsText(module) {
  const total = Number(module?.total_count ?? 0) || 0;
  const answered = Number(module?.answered_count ?? 0) || 0;

  return `${Math.min(answered, total)}/${total} steps`;
}

export function selectShowDescription(state) {
  return state?.showDescription ?? true;
}
